import React, { Component } from "react";
import { Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";

import eAcademyLogo from "../../assets/img/logo/logo-colors.svg";
import yesserLogo from "../../assets/img/logo/Yesser-logo.svg";

import "./NavbarHome.css";

class NavbarHome extends Component {
  state = {
    style: "",
    navOpen: this.props.isNavOpen,
    isMobile: false,
    isStickyNav: false
  };

  nav = null;
  logo = null;
  navLinks = null;

  showMenu = () => {
    this.props.onNavOpen(); // to effect to parent state on navbar opens
    this.setState({ isMobile: true, navOpen: !this.state.navOpen });
  };

  componentDidMount() {
    window.addEventListener("scroll",this.handelScroll)
  //   if(window.location.pathname === '/'){
  //     console.log('home')
  //     this.nav = document.querySelector("#navigation");
  //     this.logo = document.querySelector(".logo");
  //   this.navLinks = document.querySelectorAll(".nav-link");
  //   window.addEventListener("scroll", () => {
  //     // console.log('scroll');
      
  //     // Start syicky navigation on scroll
  //     this.stickyNavigation();
      
  //     // Change active section on scroll
  //     this.activeSectionOnScroll();
  //   });
  // }
}

handelScroll = () =>{
  this.nav = document.querySelector("#navigation");
  this.logo = document.querySelector(".logo");
  this.navLinks = document.querySelectorAll(".nav-link");
  // console.log('scroll');
  
  // Start syicky navigation on scroll
  this.stickyNavigation();
  
  // Change active section on scroll
  this.activeSectionOnScroll();

}

  componentWillUnmount(){    
    window.removeEventListener('scroll',this.handelScroll)
  }

  stickyNavigation = () => {
    if (
      window.pageYOffset > this.logo.clientHeight + 50 &&
      window.innerWidth > 600
    ) {
      // logo height + 50px  && not in mobile view
      this.setState({ isStickyNav: true });
      this.nav.classList.add("navbar-fixed-top");
      this.logo.classList.add("hidden");
    } else {
      this.setState({ isStickyNav: false });
      this.nav.classList = "nav-home";
      this.logo.classList.remove("hidden");
    }
  };

  activeSectionOnScroll = () => {
    this.navLinks = document.querySelectorAll(".nav-link");
    const fromTop = window.scrollY;

    this.navLinks.forEach((link, i) => {
      const section = document.querySelector(link.getAttribute("href")); // to git id of the link
        //  console.log(link.getAttribute("href"));

      if (
        section &&
        section.offsetTop - 80 <= fromTop &&
        section.offsetTop + section.offsetHeight - 80 >= fromTop
      ) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  };

  isMobileView = () => {
    window.innerWidth < 600
      ? this.setState({ isMobile: true })
      : this.setState({ isMobile: false });
  };

  render() {
    return (
      <>
        <div>
          <div className="menu" onClick={this.showMenu}>
            <div className="bars" />
          </div>

          <Link to="/" className="logo-mobile">
            <img src={eAcademyLogo} alt="logo in mobile" />
          </Link>

          <nav
            id="navigation"
            className={`nav-home ${this.state.navOpen ? "nav-home-open" : ""}`}
          >
            <div className="logo has-text-centered">
              <Link to="/" className="logo-main">
                <img src={eAcademyLogo} alt="e-gov academy logo" />
              </Link>
              <Link to="/" className="logo-main">
                <img src={yesserLogo} alt="yesser logo" />
              </Link>
            </div>
            <ul className="nav-list is-flex">
              <li className="nav-item">
                <AnchorLink
                  href="#home"
                  className="nav-link active"
                  data-text="الرئيسية"
                >
                  الرئيسية
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink
                  href="#about"
                  className="nav-link"
                  data-text="عن الأكاديمية"
                >
                  عن الأكاديمية
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink
                  href="#goals"
                  className="nav-link"
                  data-text="الأهداف"
                >
                  الأهداف
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink
                  href="#programs"
                  className="nav-link"
                  data-text="البرامج"
                >
                  البرامج
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink
                  href="#accomplishments"
                  className="nav-link"
                  data-text="الانجازات"
                >
                  الانجازات
                </AnchorLink>
              </li>

              <li className="nav-item">
                <AnchorLink
                  href="#contact-us"
                  className="nav-link"
                  data-text="تواصل معنا"
                >
                  تواصل معنا
                </AnchorLink>
              </li>
            </ul>
          </nav>
        </div>
      </>
    );
  }
}

export default NavbarHome;
